import * as React from "react"
import { useState, useCallback, useEffect, useRef } from "react";
import './App.css'

import SkillCard from "./Components/SkillCard"
import WindowsCard from "./Components/WindowsComponentCard/WindowsCard"
import MacCard from "./Components/MacComponentCard/MacCard"
import MessageForm from "./Components/MessageForm/MessageForm"
import SkillTextCard from "./Components/SkillTextCard"
import WaveGuy from "./Components/p5art/WaveGuy"
import SolarSystem3D from './Components/p5art/SolarSystem3D'
import SinWave from './Components/p5art/SinWave';
import PerlinNoise2D from "./Components/p5art/PerlinNoise2D"
import TimesTables from "./Components/p5art/TimesTables"
import Kaleidoscope2D from "./Components/p5art/Kaleidoscope2D"
import TaurusAnimation from './Components/p5art/TorusAnimation'
import CubeAnimation from "./Components/p5art/CubeAnimation"
import SineWaveGraph from "./Components/p5art/SineWaveGraph"
import TriangleWaveAnimation from "./Components/p5art/TriangleWaveAnimation"
import SphereAnimation from "./Components/p5art/SphereAnimation"
import PongGame from "./Components/p5art/PongGame"
import FallingObstaclesGame from "./Components/p5art/FallingObstaclesGame"
import FlowArt from "./Components/p5art/FlowArt"
import InteractiveArt from "./Components/p5art/InteractiveArt"
import InteractiveDrawing from "./Components/p5art/InteractiveDrawing"
import PointingRectangles from "./Components/p5art/PointingRectangles"
import WaterWaves from "./Components/p5art/WaterWaves"

import letterseparate from "../images/letter-separate.png"
import endletterbar from "../images/endletterbar.png"

import zipRipped from "../images/artportfolio/zipRipped.png"
import cracked from "../images/artportfolio/cracked-web.png"
import ringSit from "../images/artportfolio/ringSit.png"
import ordering from "../images/artportfolio/nathanOrdering-web.png"
import tornApart2 from "../images/artportfolio/tornApart2-web.png"
import tornChain from "../images/artportfolio/tornChainNOBG-web.png"
import embryo from "../images/artportfolio/embryov2-web.png"
import tapePaper from "../images/notepapertaped.png";
import brickWall from "../images/brickwall.png"
import lips from "../images/lips.png"


import waitingRoom from "../images/artportfolio/waitingRoom-web.png"
import redtack from "../images/redtack.png"
import greentack from "../images/greentack.png";
import yellowtack from "../images/yellowtack.png";
// import bulletHole from "../images/bullethole.png"
// import HeartRateMonitor from "./Components/p5art/HeartRateMonitor"
import MarqueeCard from "./Components/MarqueeCard/MarqueeCard"
import FloorToolbar from "./Components/FloorToolbar/FloorToolbar"
import Annex from "./Components/Annex/Annex"
import SystemCrash from "./Components/SystemCrash/SystemCrash"
import XrayLens from "./Components/Xray/XrayLens"
import AmbientLayer from "./Components/Ambient"
import PlayerDock from "./Components/PlayerDock/PlayerDock"
import AngelicBumperView from "./Components/AngelicBumperView/AngelicBumperView"
import HolyBumperButton from "./Components/HolyBumperButton/HolyBumperButton"
import Dancers from "./Components/Dancers/Dancers"
import PinInspector from "./Components/PinInspector/PinInspector"
import "./Components/Ambient/cursor.css"
import { AiFillCloseCircle } from "react-icons/ai";

import $ from 'jquery';

// Sound url imports
// import waveguysound from '../sounds/waveguysound.wav'

let tacks = [
  redtack,
  greentack,
  yellowtack
];

function ArtCard(props) {
  // On desktop the art image scales on :hover. Touch devices have no hover, so
  // we expose the same payoff on tap by toggling an .is-tapped class (the CSS
  // touch media query scales .art-image.is-tapped). Pointer events cover mouse,
  // touch, and pen uniformly; desktop hover is untouched.
  const [tapped, setTapped] = useState(false);
  return (
    <div className="art-card-wrapper">
      <img
        className={"art-image" + (tapped ? " is-tapped" : "")}
        src={props.imageSrc}
        alt=""
        onClick={() => setTapped((t) => !t)}
      />
      <img className="tack" src={tacks[Math.floor(Math.random() * 3)]} alt="" />
    </div >
  );
}

const App = () => {

  const [filterEnabled, setFilterEnabled] = useState(true);
  const [gridEnabled, setGridEnabled] = useState(true);
  const [inversionEnabled, setInversionEnabled] = useState(false);
  const [soundEnabled, setSoundEnabled] = useState(true);
  const [aboutEnabled, setAboutEnabled] = useState(false);
  const [annexEnabled, setAnnexEnabled] = useState(false);
  const [vhsEnabled, setVhsEnabled] = useState(true);
  const [xrayEnabled, setXrayEnabled] = useState(false);
  const [bumperOpen, setBumperOpen] = useState(false);
  // The prominent Seraphim Bumper portal stays hidden until the visitor passes
  // through the crash + reboot and is met with the closing benediction. Holiness
  // is revealed only after that reverent moment — not blaring at the top on load.
  const [holinessRevealed, setHolinessRevealed] = useState(false);

  // A subtle thank-you that rests quietly at the very BOTTOM of the page — NOT a
  // modal/overlay. It surfaces gently once the visitor has passed through the
  // crash (the same reverent moment that reveals the holy portal), replacing the
  // old full-screen benediction with something soft and unobtrusive.
  const [thanksRevealed, setThanksRevealed] = useState(false);

  // The music dock stays hidden until the page has FULLY loaded AND the one-shot
  // boot intro (BootEye) has finished, so it never pops in over the load
  // animation. Both conditions are tracked in refs and flip dockReady once.
  const [dockReady, setDockReady] = useState(false);
  const bootDoneRef = useRef(false);
  const pageLoadedRef = useRef(false);

  const annexRef = useRef(null);
  // SystemCrash stashes its replay() here so the descend hatch can re-fire the
  // crash on demand even after it's been seen this session.
  const crashReplayRef = useRef(null);

  // Reveal + travel to the Annex from the bottom-of-board hatch. If the crash
  // hasn't been discovered yet this session, replay it as the dramatic entrance;
  // otherwise just unlock and smooth-scroll down to the wing.
  const descendToAnnex = useCallback(() => {
    if (!annexEnabled) {
      setAnnexEnabled(true);
    } else {
      // Already unlocked — travel down to the TOP of the wing. We OFFER a smooth
      // glide as a nicety, but we never DEPEND on it: a smooth scroll over the
      // very long distance down to the wing can be interrupted or silently
      // no-op (browser quirk), which would strand the visitor back at the top.
      // So we ALWAYS re-assert the precise absolute top with an INSTANT jump on
      // the next frame AND on a short timeout fallback — exactly the same
      // reliable landing the crash-reveal path uses — so we always end at the
      // beginning of the wing, never partway, never at the bottom, never at 0.
      const node = annexRef.current;
      if (node) {
        const prefersReduced =
          typeof window.matchMedia === "function" &&
          window.matchMedia("(prefers-reduced-motion: reduce)").matches;
        const landAtTop = () => {
          const n = annexRef.current;
          if (!n) return;
          const top = n.getBoundingClientRect().top + window.scrollY;
          window.scrollTo({ top, left: 0, behavior: "auto" });
        };
        if (prefersReduced) {
          landAtTop();
        } else {
          const top = node.getBoundingClientRect().top + window.scrollY;
          window.scrollTo({ top, left: 0, behavior: "smooth" });
        }
        // Re-assert the exact top INSTANTLY (next frame + a short fallback) so a
        // failed/interrupted smooth pass or sub-pixel layout drift can never
        // leave the heading clipped above the fold or the page back at the top.
        window.requestAnimationFrame(landAtTop);
        setTimeout(landAtTop, 700);
      }
    }
  }, [annexEnabled]);

  // Flip dockReady only when BOTH the boot intro is done and the window has
  // fully loaded; idempotent so either trigger can complete the gate.
  const revealDock = useCallback(() => {
    if (bootDoneRef.current && pageLoadedRef.current) setDockReady(true);
  }, []);

  // Called by BootEye (via AmbientLayer) when the boot animation finishes — or
  // immediately if it was already seen this session (no intro left to wait for).
  const handleBootDone = useCallback(() => {
    bootDoneRef.current = true;
    revealDock();
  }, [revealDock]);

  // Wait for the whole page (images/fonts/etc.) to finish loading before the
  // dock may appear. Plus a safety net so a missed signal (throttled tab, a
  // slow asset) can never leave the dock hidden forever.
  useEffect(() => {
    const onLoad = () => {
      pageLoadedRef.current = true;
      revealDock();
    };
    if (document.readyState === "complete") {
      onLoad();
    } else {
      window.addEventListener("load", onLoad);
    }
    const safety = setTimeout(() => setDockReady(true), 8000);
    return () => {
      window.removeEventListener("load", onLoad);
      clearTimeout(safety);
    };
  }, [revealDock]);

  // Deliberately re-run the crash sequence (re-discoverable feature), then it
  // unlocks the Annex on reboot as usual.
  const triggerCrash = useCallback(() => {
    if (typeof crashReplayRef.current === "function") {
      crashReplayRef.current();
    } else {
      // Crash unavailable for some reason — fall back to a plain descend.
      descendToAnnex();
    }
  }, [descendToAnnex]);

  // When the Annex is revealed, reliably land at the BEGINNING (top) of the
  // wing. The Annex mounts heavy content (p5 sketches, images) that keeps
  // GROWING for a while after the section first paints. The old approach used a
  // SMOOTH scrollIntoView, but a smooth scroll is animated over time: it's
  // launched toward a target offset, and while it's still travelling the Annex
  // grows TALLER (images + p5 canvases lay in below), so the animation chases a
  // moving target and routinely overshoots — dumping the visitor at the very
  // BOTTOM of the wing. The robust fix:
  //   1. measure the Annex's ABSOLUTE document top each time and jump there
  //      INSTANTLY with window.scrollTo (no animation to overshoot), and
  //   2. re-assert that exact position across several frames/timeouts AND every
  //      time an <img> inside the Annex finishes loading (the real cause of the
  //      late growth), so the page can never settle anywhere but the top.
  // Reduced motion changes nothing here — the jump is already instant.
  useEffect(() => {
    if (!annexEnabled) return undefined;

    const rafs = [];
    const timers = [];
    let cancelled = false;
    const loadedImgs = [];

    // Absolute top of the Annex in the document, then an INSTANT jump there.
    // Using getBoundingClientRect()+scrollY (rather than scrollIntoView) means
    // we compute against the Annex's *current* laid-out height every call, and
    // an instant jump has no in-flight animation that a later growth can derail.
    const scrollToAnnexTop = () => {
      const node = annexRef.current;
      if (!node || cancelled) return;
      const top = node.getBoundingClientRect().top + window.scrollY;
      window.scrollTo({ top, left: 0, behavior: "auto" });
    };

    // Land at the top as early as possible: jump synchronously the moment the
    // Annex has mounted (this effect runs right after React commits the section,
    // so annexRef.current is already the .annex-page node), THEN keep re-asserting.
    scrollToAnnexTop();

    // Defer past first layout: rAF -> rAF, then re-assert on a few timeouts so a
    // late reflow (p5 canvases sizing themselves) can't leave us off-target.
    rafs.push(
      window.requestAnimationFrame(() => {
        rafs.push(
          window.requestAnimationFrame(() => {
            scrollToAnnexTop();
            [120, 300, 600, 1000].forEach((ms) =>
              timers.push(setTimeout(scrollToAnnexTop, ms))
            );

            // The biggest source of late growth is images loading INSIDE the
            // Annex. Re-snap to the top the instant each one finishes (or
            // errors), so the wing settling into its full height always keeps
            // the top pinned to the viewport top.
            const node = annexRef.current;
            if (node) {
              const imgs = node.querySelectorAll("img");
              imgs.forEach((img) => {
                if (img.complete) return;
                const onImg = () => scrollToAnnexTop();
                img.addEventListener("load", onImg);
                img.addEventListener("error", onImg);
                loadedImgs.push([img, onImg]);
              });
            }
          })
        );
      })
    );

    // If the whole page is still streaming in, re-snap once it finishes too.
    const onLoad = () => scrollToAnnexTop();
    if (document.readyState !== "complete") {
      window.addEventListener("load", onLoad, { once: true });
    }

    return () => {
      cancelled = true;
      rafs.forEach((id) => window.cancelAnimationFrame(id));
      timers.forEach((t) => clearTimeout(t));
      loadedImgs.forEach(([img, fn]) => {
        img.removeEventListener("load", fn);
        img.removeEventListener("error", fn);
      });
      window.removeEventListener("load", onLoad);
    };
  }, [annexEnabled]);

  React.useEffect(() => {
    $(".tile").on({
      mouseenter() {
        $(this).addClass("tile-ani");
      },
      animationend() {
        $(this).removeClass("tile-ani");
      },
    });
  }, []);

  const toggleFilter = (t) => {
    setFilterEnabled(t);
  }

  const toggleGrid = (t) => {
    setGridEnabled(t);
  }

  const toggleInversion = (t) => {
    setInversionEnabled(t);
  }


  // Mute a singular HTML5 element
  function muteMe(elem, t) {
    elem.muted = t;

    if (!t) {
      elem.play();
    }
    else {
      elem.pause();
    }
  }

  // Try to mute all video and audio elements on the page
  function mutePage(t) {
    document.querySelectorAll("video, audio").forEach((elem) => muteMe(elem, t));
  }

  const toggleSound = (t) => {
    setSoundEnabled(t);
    mutePage(!t);
  }

  const toggleAboutEnabled = () => {
    setAboutEnabled(!aboutEnabled);
  }

  const toggleAnnex = (t) => {
    setAnnexEnabled(t);
  }

  const toggleVhs = (t) => {
    setVhsEnabled(t);
  }

  const toggleXray = (t) => {
    setXrayEnabled(t);
  }

  const generateTiles = (n) => {
    let tileArray = [];

    for (let i = 0; i < n; i++) {
      tileArray.push(<div className="tile" key={i}></div>);
    }

    return tileArray;
  }

  // Drag/click pass-through handle for the cards. Intentionally a no-op for now
  // (cards manage their own bring-to-front), kept so the prop contract holds.
  const onClickWindow = useCallback(() => {}, []);

  return (
    <React.Fragment>
      <PinInspector />
      <AmbientLayer vhsEnabled={vhsEnabled} onBootDone={handleBootDone} />
      <Dancers />
      {dockReady ? (
        <PlayerDock sound={soundEnabled} onOpenBumper={() => setBumperOpen(true)} />
      ) : null}
      <AngelicBumperView open={bumperOpen} onClose={() => setBumperOpen(false)} sound={soundEnabled} />
      <SystemCrash
        soundEnabled={soundEnabled}
        onUnlock={() => {
          setAnnexEnabled(true);
          // The crash is where the closing word is unveiled — surface the
          // prominent Seraphim Bumper portal AND the quiet bottom thank-you from
          // this moment on.
          setHolinessRevealed(true);
          setThanksRevealed(true);
        }}
        replayRef={crashReplayRef}
      />
      <XrayLens active={xrayEnabled} onDisable={() => setXrayEnabled(false)} />
      <div className="about-coverpage-wrapper" style={{ visibility: (aboutEnabled ? "visible" : "hidden") }} onClick={null}>
        <div className="close-about-btn" onClick={toggleAboutEnabled}>
          <AiFillCloseCircle />
        </div>
        <h1>
          - About this site -
        </h1>
        <div className="about-window">
          <h2>
            Welcome to the <span className="italics ambu-color">Ambulation Zone</span>
          </h2>

          <div className="letter-separator-wrap">
            <img className="letter-separator" src={letterseparate} />
          </div >

          <div className="about-text-wrap">
            <h3>
              Dearest,
            </h3>

            <h5>
              - What is this place? -
            </h5>
            <p>
              The <span className="italics ambu-color">Ambulation Zone</span> is an ideaboard-space.  Any visual, practical, interactive related development ideas that may come to mind may lead to fruition in this zone.
            </p>

            <hr></hr>

            <h5>
              - Who? -
            </h5>

            <p>
              My name is <span className="my-name">Nathan Breen</span>, I'm a <span className="what-i-am">UX/UI designer</span> and <span className="what-i-am2">Software Developer</span>.
            </p>


            <hr></hr>

            <h5>
              - Thank you -
            </h5>

            <div className="thank-you">
              Thank you for stopping by this site.  Take care.
            </div>
          </div>

          <div className="letter-separator-wrap">
            <img className="letter-separator" src={endletterbar} />
          </div >
          <div className="sig-padding">
            <h4>
              Much obliged,
            </h4>

            <h6>
              <span className="my-name">
                Nathan Breen
              </span>
            </h6>
          </div>

        </div>
      </div>
      <body className={"ambu-cursor " + (inversionEnabled ? "invert " : "") + (aboutEnabled ? "blur " : "")}>
        <div className="header-wrap">
          <div className="bolt-wrapper">
            <div className="rivot" style={{ transform: "rotateZ(" + (Math.random() * 25) + "deg)" }} />
            <div className="rivot" style={{ transform: "rotateZ(" + (Math.random() * 25) + "deg)" }} />
          </div>
          <div className="left-header-wrap">

            <div className="header-coin-wrap coin-left">
              <div className="coin-face header-coin-front">
                <p className="coin-text">
                  %
                </p>
              </div>
              <div className="coin-face header-coin-back">
                <p className="coin-text text-purp">
                  &
                </p>
              </div>
            </div>

          </div>

          <div className="title-wrap">
            <div className="double-vision">
              <div className="title-text">
                <span className="title-span1">- AMBULATION ZONE -</span>
              </div>

              {/* <div className="title-text">
                <span className="title-span2">- AMBULATION ZONE -</span>
              </div> */}
            </div>
            <div className="lightboxes">
              <div className="lbox1" />
              <div className="lbox2" />
              <div className="lbox3" />
              <div className="lbox4" />
            </div>
          </div>
          <div className="about-info-wrapper">
            <div className="about-info" onClick={toggleAboutEnabled}>
              ?
            </div>
          </div>
          <div className="bolt-wrapper">
            <div className="rivot" style={{ transform: "rotateZ(" + (Math.random() * 25) + "deg)" }} />
            <div className="rivot" style={{ transform: "rotateZ(" + (Math.random() * 25) + "deg)" }} />
          </div>
        </div>

        {/* The reverent invitation to the holiest chamber of this sacred site:
            the Seraphim Bumper. A can't-miss, awe-inspiring primary portal,
            placed full-width directly beneath the header — but only AFTER the
            visitor has passed through the crash + reboot and been met with the
            closing benediction. Until then it stays hidden; the PlayerDock
            launcher remains the quiet way in. */}
        {holinessRevealed ? <HolyBumperButton onEnter={() => setBumperOpen(true)} /> : null}

        <div className={"program-art-page " + (gridEnabled ? "" : "background-none")}>
          <div className={"page-filter " + (filterEnabled ? "" : "background-none")}></div>
          <div className="art-windows">
            <SkillCard id="sinwave" handleDrag={onClickWindow} setId={"sinwave"} programText="sinwave.p5" artComp={<SinWave />} />
            <WindowsCard id="marquee" handleDrag={onClickWindow} className="window-item" programText="X:/marquee.css" artComp={<MarqueeCard sound={soundEnabled} />} />

            {/* The Seraphim Bumper as its own draggable program in the main web —
                reachable at ANY moment, no crash required. It's an affordance
                that opens the full-screen Seraphim Bumper (setBumperOpen(true));
                the dock launcher and the post-crash holy portal both remain. */}
            <WindowsCard
              id="angelic-bumper"
              handleDrag={onClickWindow}
              className="window-item"
              programText="SERAPHIM-BUMPER.EXE"
              artComp={
                <div
                  className="angelic-bumper-program"
                  role="button"
                  tabIndex={0}
                  aria-label="Open the Seraphim Bumper"
                  onClick={() => setBumperOpen(true)}
                  onKeyDown={(e) => {
                    if (e.key === "Enter" || e.key === " " || e.key === "Spacebar") {
                      e.preventDefault();
                      setBumperOpen(true);
                    }
                  }}
                >
                  <div className="angelic-bumper-halo" aria-hidden="true" />
                  <div className="angelic-bumper-glyph" aria-hidden="true">✦</div>
                  <div className="angelic-bumper-title">SERAPHIM BUMPER</div>
                  {/* A small reverent caption — the scripture line the program
                      is named for (Isaiah 6:2). */}
                  <div className="angelic-bumper-verse">Above him stood the seraphim.</div>
                  <div className="angelic-bumper-cta">▸ run program</div>
                </div>
              }
            />

            <ArtCard imageSrc={zipRipped} />

            <WindowsCard id='waveguy' soundUrl={null} sound={soundEnabled} programText="C:/wave-guy.p5" artComp={<WaveGuy />} />
            <ArtCard imageSrc={embryo} />
            <SkillCard programText="pong.p5" artComp={<PongGame />} />

            {/* THE FUCKING GUY! */}
            <div className="senior-bumpis">
              <WindowsCard id='muah' className="window-item" programText="X:/muah-XOXO" artComp={
                <img className="art-image" src={lips} style={{ boxShadow: "none", background: "#000", width: "400px", borderRadius: "0" }} />
              } />
            </div>

            <div className="senior-bumpis" style={{ flexDirection: "column" }}>
              <ArtCard imageSrc={ringSit} />
              <ArtCard imageSrc={tornApart2} />
            </div>

            <WindowsCard className="window-item" programText="X:/type-it-out" artComp={
              <div className="tile-drawer-wrap">
                {
                  generateTiles(400).map((tile) => tile)
                }
              </div>
            } />

            <MacCard id='mrwaveguy' programText="Mr.-Waveguy" underbartext="Move like water---" artComp={<WaterWaves />} />
            <WindowsCard soundUrl={null} sound={soundEnabled} programText="C:/barber.css" artComp={
              <React.Fragment>
                <div className="barber-wrapper">
                  <div className="barber-inner">
                    <div className="barber"></div>
                    <div className="barber"></div>
                  </div>
                </div>
              </React.Fragment>
            } />
            <SkillTextCard programText="What does it all mean?" titleText="What is this?" skillsText="Cosmic tapestry of existence, fungal beings slumber, 
            their mycelial tendrils weaving through the shadows. 
            Life, a fleeting illusion, succumbs to their ancient dance. 
            Spores whisper forgotten truths, 
            heralding an era where boundaries blur, 
            and the world trembles in ominous anticipation." />
            <div className="art-card-wrapper" style={{ height: "250px" }}>
              <img className="art-image" src={tapePaper} style={{ boxShadow: "none" }} />
            </div >
            <MacCard programText="they-are-looking.p5" artComp={<PointingRectangles />} />
            <WindowsCard programText="C:/color-wheel.p5" artComp={<Kaleidoscope2D />} />
            <ArtCard imageSrc={cracked} />

            <MessageForm programText="Shoot me a messsage!" />
            <div className="art-card-wrapper">
              <img className="art-image" src={brickWall} style={{ boxShadow: "none" }} />
            </div >
            <MacCard programText="timesTables.p5" artComp={<TimesTables />} />
            <SkillTextCard programText="a lot" titleText="There's a lot going on here." bgColor="#333" titleColor="#fff" textColor="#FFFC33"
              skillsText="I know." />
            <WindowsCard programText="wavegen.p5" artComp={<SineWaveGraph />} />
            <SkillCard programText="bigsmall.p5" artComp={<InteractiveArt />} />
            <div className="art-card-wrapper">
              <img className="art-image" src={tornChain} style={{ boxShadow: "none" }} />
            </div >
            <MacCard programText="hover-square.p5" artComp={<InteractiveDrawing />} />
            <SkillTextCard programText="Any others?" titleText="It's for display." bgColor="#80008b" titleColor="#FFF" textColor="#fff"
              skillsText="
            Bathed in moonlight, the greenhouse quivered. 
            Roots crawled, leaves whispered in the darkness. 
            Silent witnesses watched as the plants, once motionless, twisted in an unholy dance. 
            A cursed spectacle, visible only to those fortunate souls drawn into their sinister performance, bound to secrecy or doomed to join the foliage's malevolent waltz.
            " />

            <WindowsCard programText="hover-flow.p5" artComp={<FlowArt />} />
            <SkillCard programText="terrain-generation.p5" artComp={<PerlinNoise2D />} />
            <ArtCard imageSrc={waitingRoom} />
            <SkillCard programText="hoolahoop.p5" artComp={<SphereAnimation />} />
            <ArtCard imageSrc={ordering} />
            <SkillCard programText="tangent-spaceinvaders.p5" artComp={<TriangleWaveAnimation />} />
            <SkillCard programText="solar-system.p5" artComp={<SolarSystem3D />} />
          </div>

          {/* Bottom-of-board entrance to THE ANNEX. Obvious when you reach the
              end of the surface board: an industrial floor hatch that either
              re-triggers the kernel-panic crash (first descent of the session)
              or, once unlocked, just opens + scrolls down to the wing. */}
          <div className="annex-hatch-wrap">
            <div
              className={"annex-hatch" + (annexEnabled ? " annex-hatch-open" : "")}
              role="button"
              tabIndex={0}
              aria-label={annexEnabled ? "Descend to the Annex" : "Descend below the floor to the Annex"}
              onClick={annexEnabled ? descendToAnnex : triggerCrash}
              onKeyDown={(e) => {
                if (e.key === "Enter" || e.key === " " || e.key === "Spacebar") {
                  e.preventDefault();
                  (annexEnabled ? descendToAnnex : triggerCrash)();
                }
              }}
            >
              <div className="annex-hatch-rivets">
                <span className="annex-hatch-rivet" />
                <span className="annex-hatch-rivet" />
              </div>
              <div className="annex-hatch-label">
                <span className="annex-hatch-chevrons">▼ ▼ ▼</span>
                <span className="annex-hatch-main">DESCEND TO THE ANNEX</span>
                <span className="annex-hatch-sub">
                  {annexEnabled
                    ? "the second wing is open below"
                    : "something is ambulating beneath the floor"}
                </span>
              </div>
              <div className="annex-hatch-rivets">
                <span className="annex-hatch-rivet" />
                <span className="annex-hatch-rivet" />
              </div>
            </div>
          </div>
        </div>
        {annexEnabled ? <Annex soundEnabled={soundEnabled} annexRef={annexRef} /> : null}

        {/* A SUBTLE thank-you that rests quietly at the bottom of the page — a
            small footer-style note, not a modal/overlay. It surfaces gently
            after the crash (thanksRevealed) and simply stays present down here.
            Wholehearted, warm, and universal. */}
        {thanksRevealed ? (
          <footer className="page-thankyou" role="contentinfo">
            <p className="page-thankyou-text">Thank you kindly for stopping by</p>
          </footer>
        ) : null}
      </body>

      {
        (aboutEnabled ? null : <FloorToolbar sound={soundEnabled} tFilter={toggleFilter} tGrid={toggleGrid} tInversion={toggleInversion} tSounds={toggleSound} tAnnex={toggleAnnex} tVhs={toggleVhs} tXray={toggleXray} />
        )
      }
    </React.Fragment>
  )
}

export default App

export const Head = () => <title>Ambulation Zone</title>
